import React from 'react';
import isEqual from 'react-fast-compare';

import SignedExtFileURLProxy from 'external-files/SignedExtFileURLProxy';
import {Image as ImageType} from 'notebook/protocols/types/ImageType';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface Props {
  image: ImageType;
  owningEntityApiId: string;
  versionId: number;
}

class Image extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props): boolean {
    return !isEqual(this.props, nextProps);
  }

  render(): JSX.Element {
    if (this.props.image.url) {
      if (this.props.image.key) {
        return (
          <div className="procedure-image">
            <SignedExtFileURLProxy
              url={this.props.image.url}
              externalFileId={this.props.image.key}
              renderWithSignedURL={(signedURL: string) => <img src={signedURL} />}
              owningEntityApiId={this.props.owningEntityApiId}
              versionId={this.props.versionId}
            />
          </div>
        );
      } else {
        return (
          <div className="procedure-image">
            <img src={this.props.image.url} />
          </div>
        );
      }
    } else {
      return (
        <div className="procedure-image">
          <BenchlingIcon icon="image" />
        </div>
      );
    }
  }
}

export default Image;
